import { School } from '../school';
import { Student } from '../student';
import { SubscriptionType } from '../subscription-type';
export class Enrollment {
    constructor(
        public id?: number,
        public validUntil?: any,
        public validSince?: any,
        public price?: number,
        public totalPaid?: number,
        public school?: School,
        public student?: Student,
        public subscriptionType?: SubscriptionType,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/enrollment/enrollment.model.ts